<ui-section
	title="Salutations & RE lines"
	intercom="file-salutations-client"
	[testHook]="testHooks.Section"
>
	<ui-button
		size="sm"
		(click)="reset()"
		actions
		preset="MEDIUM_EMPHASIS"
		label="Revert to default settings"
		[testHook]="testHooks.RevertToDefaultSettingsButton"
	/>
	<div section-content>
		<div class="flex flex-col lg:flex-row pb-2 gap-8">
			<div class="full-width-md lg:w-1/2">
				<div>
					<app-dropdown
						(onSelect)="primarySalutationTypeChanged($event)"
						[ngModel]="primaryType"
						label="Primary salutation type"
						inputClasses="captialize"
						class="mt-4"
						[itemGroups]="[{ items: salutationTypesDropdownOptions }]"
						[testHook]="testHooks.PrimarySalutationTypeDropdown"
					>
					</app-dropdown>
					<app-input
						label="Primary salutation"
						class="mt-4"
						[ngModel]="(salutations$ | async)?.primary"
						(debounce)="primarySalutationChanged($event)"
						[testHook]="testHooks.PrimarySalutation"
					></app-input>
				</div>
			</div>
			<div class="full-width-md lg:w-1/2">
				<div>
					<app-dropdown
						(onSelect)="envelopeSalutationTypeChanged($event)"
						[ngModel]="envelopeType"
						label="Envelope salutation type"
						class="mt-4"
						[itemGroups]="[{ items: salutationTypesDropdownOptions }]"
						[testHook]="testHooks.EnvelopeSalutationTypeDropdown"
					>
					</app-dropdown>
					<app-input
						label="Envelope salutation"
						class="mt-4"
						[ngModel]="(salutations$ | async)?.envelope"
						(debounce)="envelopeSalutationChanged($event)"
						[testHook]="testHooks.EnvelopeSalutation"
					></app-input>
				</div>
			</div>
		</div>
		<div class="flex justify-between items-center mt-4">
			<div class="w-1/2">
				<div class="mb-3">
					<p class="mb-2">Re line type</p>
					<app-radio-group
						[items]="reLineTypes"
						type="compact"
						class="mb-4"
						[ngModel]="selectedReLineType"
						(ngModelChange)="setRelineType($event)"
						[testHook]="testHooks.SelectedReLineTypeRadioGroup"
					></app-radio-group>
					<p>
						Document tag:
						<span class="font-bold">{{ selectedReLineType }}</span>
					</p>
				</div>
				<div class="flex justify-between my-4">
					<ui-button
						label="Edit Text"
						(click)="
							editText(
								matterId,
								selectedReLineType,
								getReline(selectedReLineType),
								selectedReLineType
							)
						"
						intercomAttr="file-salutation-edit"
						preset="MEDIUM_EMPHASIS"
						icon="edit"
						[testHook]="testHooks.EditTextButton"
					/>
				</div>
			</div>
		</div>
	</div>
</ui-section>
